import { z } from 'zod';

export const generateReportRequest = z.object({
  body: z.object({
    projectId: z.string(),
    projectTitle: z.string(),
  }),
});

export type GenerateReportRequest = z.infer<typeof generateReportRequest>;

export type GenerateReportResponse = String;

export const updateEmailNotificationRequest = z.object({
  params: z.object({
    projectId: z.string(),
  }),
  body: z.object({
    isEnabled: z.boolean(),
    dayOfWeek: z.number().min(1).max(7),
    time: z.string().regex(/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/),
  }),
});

export type UpdateEmailNotificationRequest = z.infer<
  typeof updateEmailNotificationRequest
>;

export type UpdateEmailNotificationResponse = {
  id: string;
  isEnabled: boolean;
  dayOfWeek: number;
  time: string;
};

export const getEmailNotificationSettingsRequest = z.object({
  params: z.object({
    projectId: z.string(),
  }),
});

export type GetEmailNotificationSettingsRequest = z.infer<
  typeof getEmailNotificationSettingsRequest
>;

export interface EmailNotificationSettings {
  isEnabled: boolean;
  dayOfWeek: number;
  time: string;
}

export type GetEmailNotificationSettingsResponse = {
  isEnabled: boolean;
  dayOfWeek: number;
  time: string;
};

// Request schema for email cron job webhook endpoint
export const checkEmailRequest = z.object({
  params: z.object({}).optional(),
  query: z.object({}).optional(),
  body: z.object({}).optional(),
  headers: z
    .object({
      'vercel-cron-signature': z.string(),
    })
    .optional(),
});

export type CheckEmailRequest = z.infer<typeof checkEmailRequest>;

// Response type for email notification processing summary
export type CheckEmailResponse = {
  message: string;
  processed: number;
  summary?: {
    success: number;
    failed: number;
    skipped: number;
    skipReasons?: Record<string, number>;
    errors?: Array<{
      projectId?: string;
      error: string;
    }>;
  };
};
